// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "geral-bundle" + "." + "4ebb53b4" + ".css";
};